"use client";
import Link from "next/link";

export default function GuideSidebar() {
  return (
    <div className="space-y-8">
      {/* CTA */}
      <div className="rounded-xl bg-brand-primary p-6 text-white">
        <p className="text-xs font-semibold uppercase tracking-wider text-white/60">
          Book help
        </p>
        <p className="mt-2 font-heading text-lg font-bold leading-snug">
          Fixed price in 2&nbsp;min — no hidden costs.
        </p>
        <p className="mt-2 text-sm leading-relaxed text-white/80">
          Our own vans, fair working conditions and up to 50&nbsp;% RUT tax deduction.
        </p>
        <Link
          href="/en/book"
          className="mt-4 inline-flex w-full items-center justify-center rounded-lg bg-white px-5 py-2.5 text-sm font-bold text-brand-primary transition-colors hover:bg-gray-100"
        >
          Book Ungdomskraft
        </Link>
      </div>
    </div>
  );
}
